// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"2518419d","200":"aff51223","261":"2c220afc","309":"051da651","323":"b054f408","620":"a7588a19","768":"e28720d1"}[chunkId] + ".css";
};